import React, { useContext } from 'react';
import IconAndTextComponent from '../components/IconAndTextComponent';
import CardTitle from '../components/CardTitle';
import { ContextPaymentTerms } from '../../contexts/PaymentTermsContext';
import { sortByName } from '../../utils/sortByName';
import { Grid } from '@mui/material';
import InfoIcon from '../../components/InfoIcon';

const NonEditionContent = ({ paymentProfile: paymentData }) => {
    const { setOpenedCard } = useContext(ContextPaymentTerms);

    const address = [
        paymentData.Address,
        paymentData.PostalCode,
        paymentData.City.Caption,
        paymentData.Country.Caption,
    ]
        .filter(item => item)
        .join(' - ');

    const paymentMethodsEnabled = paymentData.PaymentMethods.filter(
        method => method.Enabled
    );
    const paymentsByPriority = sortByName(paymentMethodsEnabled, 'Priority');
    const paymentMethodsToPaint = [
        ...new Set(
            paymentsByPriority.map(payment => payment.PaymentMethod.Caption)
        ),
    ];

    return (
        <>
            <CardTitle
                title={paymentData.Name}
                onChangeViewMode={() => setOpenedCard(paymentData.Id)}
                label={'payment_profile_name'}
            />
            <Grid
                container
                rowSpacing={{ xs: 2, md: 4 }}
                columnSpacing={4}
                columns={2}
            >
                <Grid item xs={2} md={1}>
                    <IconAndTextComponent
                        icon={'AccountBalance'}
                        text={paymentData?.TaxId}
                        description={'tax_id'}
                        fontWeight={'700'}
                    />
                </Grid>
                <Grid item xs={2} md={1}>
                    <IconAndTextComponent
                        icon={'Badge'}
                        text={paymentData?.ContactName}
                        description={'billing_contact'}
                    />
                </Grid>

                <Grid item xs={2} md={1}>
                    <IconAndTextComponent
                        icon={'LocationOn'}
                        text={address}
                        description={'address'}
                    />
                </Grid>
                <Grid item xs={2} md={1}>
                    <IconAndTextComponent
                        icon={'Email'}
                        text={paymentData?.ContactEmail}
                        description={'your_email'}
                    />
                </Grid>
                <Grid item xs={2} md={1}>
                    <IconAndTextComponent
                        icon={'PhoneAndroid'}
                        text={paymentData?.ContactPhone}
                        description={'phone'}
                    />
                </Grid>
                <Grid item xs={2} md={1}>
                    <IconAndTextComponent
                        icon={'Receipt'}
                        text={paymentData?.InvoiceReceivingMethodType?.Caption}
                        description={'invoice_receiving_method'}
                    />
                </Grid>
                <Grid item xs={2} md={1}>
                    <IconAndTextComponent
                        icon={'CreditCard'}
                        text={paymentMethodsToPaint}
                        description={'payment_types'}
                        titleButtonbar={
                            <InfoIcon tooltipText='read_only_payment_types' />
                        }
                    />
                </Grid>
                <Grid item xs={2} md={1}>
                    <IconAndTextComponent
                        icon={'Payments'}
                        text={paymentData.PaymentCurrencies.map(
                            curr => curr?.Currency?.Name
                        ).filter(item => item)}
                        description={'payment_currencies'}
                        titleButtonbar={
                            <InfoIcon tooltipText='read_only_payment_currencies' />
                        }
                    />
                </Grid>
                <Grid item xs={2}>
                    <IconAndTextComponent
                        icon={'FormatListBulleted'}
                        text={paymentData.PaymentRules.map(
                            rule => rule?.Name
                        ).filter(rule => rule)}
                        description={'payment_rules'}
                        titleButtonbar={
                            <InfoIcon tooltipText='read_only_payment_rules' />
                        }
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default NonEditionContent;
